// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngb-datepicker-wrapper {
  margin-bottom: 1rem;
  position: relative;
}
.ngb-datepicker-wrapper .enhanced-label {
  font-weight: 600;
  margin-bottom: 0.5rem;
  display: block;
  font-size: 0.9rem;
  color: #2c3e50;
}
.ngb-datepicker-wrapper .enhanced-label.required::after {
  content: " *";
  color: #e74c3c;
  font-weight: bold;
}
.ngb-datepicker-wrapper .enhanced-label .label-text {
  color: #34495e;
}
.ngb-datepicker-wrapper .enhanced-label .optional-hint {
  color: #7f8c8d !important;
  font-size: 0.85em;
  font-weight: normal;
}
.ngb-datepicker-wrapper .enhanced-input-group {
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
}
.ngb-datepicker-wrapper .enhanced-input-group .datepicker-input-container {
  flex: 1;
  display: flex;
  position: relative;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  background: white;
}
.ngb-datepicker-wrapper .enhanced-input-group .datepicker-input-container:focus-within {
  border-color: #3498db;
  box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
}
.ngb-datepicker-wrapper .enhanced-input-group .datepicker-input-container.has-error {
  border-color: #e74c3c;
}
.ngb-datepicker-wrapper .enhanced-input-group .datepicker-input-container.has-error:focus-within {
  box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.1);
}
.ngb-datepicker-wrapper .enhanced-input-group .datepicker-input-container.with-time .enhanced-input.time-input {
  max-width: 140px;
  border-left: 1px solid #dee2e6;
  padding-left: 1rem;
}
.ngb-datepicker-wrapper .enhanced-input-group .datepicker-input-container.with-time.rtl-mode .enhanced-input.time-input {
  border-left: none;
  border-right: 1px solid #dee2e6;
  padding-left: 1rem;
  padding-right: 1rem;
}
.ngb-datepicker-wrapper .enhanced-input-group .enhanced-input {
  flex: 1;
  border: none !important;
  border-radius: 0 !important;
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
  background: transparent;
  transition: all 0.2s ease;
}
.ngb-datepicker-wrapper .enhanced-input-group .enhanced-input.is-disabled {
  background-color: #f8f9fa;
  color: #6c757d;
}
.ngb-datepicker-wrapper .enhanced-input-group .enhanced-input::placeholder {
  color: #adb5bd;
}
.ngb-datepicker-wrapper .enhanced-input-group .enhanced-input:focus {
  outline: none !important;
  box-shadow: none !important;
}
.ngb-datepicker-wrapper .enhanced-input-group .enhanced-calendar-btn {
  background: transparent;
  border: none;
  color: #6c757d;
  padding: 0 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.ngb-datepicker-wrapper .enhanced-input-group .enhanced-calendar-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.ngb-datepicker-wrapper .enhanced-input-group .enhanced-calendar-btn:hover:not(.btn-disabled):not(:disabled) {
  background: rgba(108, 117, 125, 0.1);
  transform: translateY(-1px);
  box-shadow: none;
}
.ngb-datepicker-wrapper .enhanced-input-group .enhanced-calendar-btn:hover:not(.btn-disabled):not(:disabled)::before {
  opacity: 1;
}
.ngb-datepicker-wrapper .enhanced-input-group .enhanced-calendar-btn:active:not(.btn-disabled):not(:disabled) {
  transform: translateY(0);
}
.ngb-datepicker-wrapper .enhanced-input-group .enhanced-calendar-btn.btn-disabled, .ngb-datepicker-wrapper .enhanced-input-group .enhanced-calendar-btn:disabled {
  background: linear-gradient(135deg, #adb5bd 0%, #6c757d 100%);
  cursor: not-allowed;
  opacity: 0.6;
}
.ngb-datepicker-wrapper .enhanced-input-group .enhanced-calendar-btn svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.ngb-datepicker-wrapper .enhanced-input-group .enhanced-calendar-btn .btn-text {
  font-size: 0.85rem;
  font-weight: 500;
  letter-spacing: 0.5px;
}
.ngb-datepicker-wrapper .enhanced-input-group .clear-btn {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #6c757d;
  padding: 0 0.75rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
}
.ngb-datepicker-wrapper .enhanced-input-group .clear-btn:hover {
  background: #e74c3c;
  border-color: #e74c3c;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(231, 76, 60, 0.3);
}
.ngb-datepicker-wrapper .enhanced-input-group .clear-btn:active {
  transform: translateY(0);
}
.ngb-datepicker-wrapper .enhanced-input-group .clear-btn svg {
  width: 16px;
  height: 16px;
}
.ngb-datepicker-wrapper .enhanced-input-group .clear-btn-inline {
  background: transparent;
  border: none;
  color: #6c757d;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.ngb-datepicker-wrapper .enhanced-input-group .clear-btn-inline:hover {
  background: rgba(231, 76, 60, 0.1);
  color: #e74c3c;
}
.ngb-datepicker-wrapper .enhanced-input-group .clear-btn-inline svg {
  width: 16px;
  height: 16px;
}
.ngb-datepicker-wrapper .enhanced-invalid-feedback {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding: 0.75rem 1rem;
  background: linear-gradient(135deg, #fff5f5 0%, #fed7d7 100%);
  border-left: 4px solid #e74c3c;
  border-radius: 0.5rem;
  animation: slideDown 0.3s ease;
}
.ngb-datepicker-wrapper .enhanced-invalid-feedback .error-icon {
  color: #e74c3c;
  flex-shrink: 0;
  animation: shake 0.5s ease;
}
.ngb-datepicker-wrapper .enhanced-invalid-feedback .error-text {
  color: #c0392b;
  font-size: 0.875rem;
  font-weight: 500;
}
.ngb-datepicker-wrapper .date-display {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding: 0.5rem 0.75rem;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 0.5rem;
  color: #0369a1;
  font-size: 0.875rem;
  font-weight: 500;
  animation: fadeIn 0.3s ease;
}
.ngb-datepicker-wrapper .date-display svg {
  flex-shrink: 0;
}
.ngb-datepicker-wrapper.rtl-mode .enhanced-input-group .datepicker-input-container {
  direction: rtl;
}
.ngb-datepicker-wrapper.rtl-mode .enhanced-input-group .datepicker-input-container .clear-btn-inline {
  right: auto;
  left: 0.5rem;
}
.ngb-datepicker-wrapper.rtl-mode .enhanced-input-group .enhanced-calendar-btn .btn-text {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.ngb-datepicker-wrapper.rtl-mode .enhanced-invalid-feedback {
  direction: rtl;
  border-left: none;
  border-right: 4px solid #e74c3c;
  text-align: right;
}
.ngb-datepicker-wrapper.rtl-mode .date-display {
  direction: rtl;
  text-align: right;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-4px);
  }
  20%, 40%, 60%, 80% {
    transform: translateX(4px);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 576px) {
  .ngb-datepicker-wrapper .enhanced-input-group {
    flex-wrap: wrap;
  }
  .ngb-datepicker-wrapper .enhanced-input-group .datepicker-input-container {
    flex-basis: 100%;
    margin-bottom: 0.5rem;
  }
  .ngb-datepicker-wrapper .enhanced-input-group .enhanced-calendar-btn,
  .ngb-datepicker-wrapper .enhanced-input-group .clear-btn {
    flex-basis: auto;
  }
  .ngb-datepicker-wrapper .enhanced-label {
    font-size: 0.85rem;
  }
  .ngb-datepicker-wrapper .enhanced-invalid-feedback {
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
  }
  .ngb-datepicker-wrapper .date-display {
    padding: 0.4rem 0.6rem;
    font-size: 0.8rem;
  }
}
@media (min-width: 992px) {
  :host ::ng-deep .ngb-datepicker {
    width: 100% !important;
  }
  :host ::ng-deep .ngb-datepicker .ngb-datepicker-day {
    width: -webkit-fill-available !important;
    min-width: 80px !important;
    min-height: 80px !important;
    padding: 12px 8px !important;
    font-size: 1.3rem !important;
  }
  :host ::ng-deep .ngb-datepicker .ngb-datepicker-weekday {
    width: -webkit-fill-available !important;
    min-width: 80px !important;
    font-size: 1.2rem !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  :host ::ng-deep .ngb-datepicker {
    width: 100% !important;
  }
  :host ::ng-deep .ngb-datepicker .ngb-datepicker-day {
    min-width: 70px !important;
    min-height: 70px !important;
    width: 70px !important;
    height: 70px !important;
    line-height: 70px !important;
    font-size: 1.2rem !important;
  }
  :host ::ng-deep .ngb-datepicker .ngb-datepicker-weekday {
    width: -webkit-fill-available !important;
    min-width: 70px !important;
    font-size: 1.1rem !important;
  }
}
ngb-datepicker,
.ngb-datepicker,
app-ngb-datepicker .ngb-datepicker,
:host ::ng-deep .ngb-datepicker {
  width: 100% !important;
  border-radius: 1rem !important;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.2) !important;
  border: none !important;
  overflow: visible !important;
  font-family: inherit !important;
  position: absolute !important;
  z-index: 1000 !important;
}
ngb-datepicker .ui-datepicker,
.ngb-datepicker .ui-datepicker,
app-ngb-datepicker .ngb-datepicker .ui-datepicker,
:host ::ng-deep .ngb-datepicker .ui-datepicker {
  display: none !important;
}
ngb-datepicker .ngb-dp-header,
.ngb-datepicker .ngb-dp-header,
app-ngb-datepicker .ngb-datepicker .ngb-dp-header,
:host ::ng-deep .ngb-datepicker .ngb-dp-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  padding: 2.5rem 3rem !important;
  border-radius: 1rem 1rem 0 0 !important;
  width: 100% !important;
  display: block !important;
}
ngb-datepicker .ngb-dp-header .ngb-datepicker-navigation,
.ngb-datepicker .ngb-dp-header .ngb-datepicker-navigation,
app-ngb-datepicker .ngb-datepicker .ngb-dp-header .ngb-datepicker-navigation,
:host ::ng-deep .ngb-datepicker .ngb-dp-header .ngb-datepicker-navigation {
  color: white !important;
  padding: 0.75rem !important;
}
ngb-datepicker .ngb-dp-header .ngb-datepicker-navigation .ngb-navigation-chevron:hover,
.ngb-datepicker .ngb-dp-header .ngb-datepicker-navigation .ngb-navigation-chevron:hover,
app-ngb-datepicker .ngb-datepicker .ngb-dp-header .ngb-datepicker-navigation .ngb-navigation-chevron:hover,
:host ::ng-deep .ngb-datepicker .ngb-dp-header .ngb-datepicker-navigation .ngb-navigation-chevron:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 50%;
}
ngb-datepicker .ngb-dp-header .ngb-datepicker-navigation .ngb-navigation-chevron svg,
.ngb-datepicker .ngb-dp-header .ngb-datepicker-navigation .ngb-navigation-chevron svg,
app-ngb-datepicker .ngb-datepicker .ngb-dp-header .ngb-datepicker-navigation .ngb-navigation-chevron svg,
:host ::ng-deep .ngb-datepicker .ngb-dp-header .ngb-datepicker-navigation .ngb-navigation-chevron svg {
  width: 24px !important;
  height: 24px !important;
}
ngb-datepicker .ngb-dp-months,
.ngb-datepicker .ngb-dp-months,
app-ngb-datepicker .ngb-datepicker .ngb-dp-months,
:host ::ng-deep .ngb-datepicker .ngb-dp-months {
  padding: 3rem !important;
  width: 100% !important;
  display: block !important;
  overflow-x: visible !important;
}
ngb-datepicker .ngb-dp-weekdays,
.ngb-datepicker .ngb-dp-weekdays,
app-ngb-datepicker .ngb-datepicker .ngb-dp-weekdays,
:host ::ng-deep .ngb-datepicker .ngb-dp-weekdays {
  width: 100% !important;
  display: table-row !important;
  table-layout: fixed !important;
}
ngb-datepicker .ngb-datepicker-month-names,
.ngb-datepicker .ngb-datepicker-month-names,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-month-names,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-month-names {
  background: #f8f9fa !important;
  padding: 2rem 3rem 1.5rem 3rem !important;
  border-bottom: 1px solid #dee2e6 !important;
  display: flex !important;
  justify-content: space-between !important;
  width: 100% !important;
}
ngb-datepicker .ngb-datepicker-month-names .ngb-month-name,
.ngb-datepicker .ngb-datepicker-month-names .ngb-month-name,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-month-names .ngb-month-name,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-month-names .ngb-month-name {
  flex: 1 !important;
  text-align: center !important;
  font-size: 1.3rem !important;
  font-weight: 500 !important;
  color: #495057 !important;
  padding: 1.25rem 0.5rem !important;
  border-radius: 0.5rem !important;
}
ngb-datepicker .ngb-datepicker-month-names .ngb-month-name:hover,
.ngb-datepicker .ngb-datepicker-month-names .ngb-month-name:hover,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-month-names .ngb-month-name:hover,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-month-names .ngb-month-name:hover {
  background: rgba(102, 126, 234, 0.1) !important;
  color: #667eea !important;
}
ngb-datepicker .ngb-dp-weekdays,
.ngb-datepicker .ngb-dp-weekdays,
app-ngb-datepicker .ngb-datepicker .ngb-dp-weekdays,
:host ::ng-deep .ngb-datepicker .ngb-dp-weekdays {
  padding: 0 2rem !important;
  display: table !important;
  width: 100% !important;
  table-layout: fixed !important;
}
ngb-datepicker .ngb-dp-weekdays .ngb-dp-weekday,
.ngb-datepicker .ngb-dp-weekdays .ngb-dp-weekday,
app-ngb-datepicker .ngb-datepicker .ngb-dp-weekdays .ngb-dp-weekday,
:host ::ng-deep .ngb-datepicker .ngb-dp-weekdays .ngb-dp-weekday {
  width: -webkit-fill-available !important;
  min-width: 80px !important;
  font-size: 1.1rem !important;
}
ngb-datepicker .ngb-datepicker-days,
.ngb-datepicker .ngb-datepicker-days,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-days,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-days {
  padding: 2rem 2rem !important;
  display: table !important;
  width: 100% !important;
  table-layout: fixed !important;
}
ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day,
.ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day {
  border-radius: 50% !important;
  transition: all 0.2s ease !important;
  padding: 12px 8px !important;
  margin: 0.2rem !important;
  font-size: 1.2rem !important;
  line-height: 1.4 !important;
  display: table-cell !important;
  text-align: center !important;
}
ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day:hover,
.ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day:hover,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day:hover,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day:hover {
  background: rgba(102, 126, 234, 0.1) !important;
}
ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day.disabled,
.ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day.disabled,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day.disabled,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day.disabled {
  color: #dee2e6 !important;
  text-decoration: line-through !important;
}
ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day.outside-month,
.ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day.outside-month,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day.outside-month,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-days .ngb-datepicker-day.outside-month {
  color: #adb5bd !important;
}
ngb-datepicker .ngb-datepicker-days .ngb-datepicker-today,
.ngb-datepicker .ngb-datepicker-days .ngb-datepicker-today,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-days .ngb-datepicker-today,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-days .ngb-datepicker-today {
  background: rgba(102, 126, 234, 0.1) !important;
  color: #667eea !important;
  font-weight: 600 !important;
  border: 2px solid #667eea !important;
}
ngb-datepicker .ngb-datepicker-days .ngb-datepicker-selected,
.ngb-datepicker .ngb-datepicker-days .ngb-datepicker-selected,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-days .ngb-datepicker-selected,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-days .ngb-datepicker-selected {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  font-weight: 600 !important;
}
ngb-datepicker .ngb-datepicker-days .ngb-datepicker-selected:hover,
.ngb-datepicker .ngb-datepicker-days .ngb-datepicker-selected:hover,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-days .ngb-datepicker-selected:hover,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-days .ngb-datepicker-selected:hover {
  background: linear-gradient(135deg, #5568d3 0%, #6a4190 100%) !important;
}
ngb-datepicker .ngb-datepicker-weekday,
.ngb-datepicker .ngb-datepicker-weekday,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-weekday,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-weekday {
  color: #6c757d !important;
  font-weight: 600 !important;
  font-size: 1.1rem !important;
  text-align: center !important;
  padding: 1.2rem 0.5rem 1rem 0.5rem !important;
  display: table-cell !important;
}
ngb-datepicker .ngb-datepicker-week-number,
.ngb-datepicker .ngb-datepicker-week-number,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-week-number,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-week-number {
  color: #adb5bd !important;
  font-size: 1.2rem !important;
  text-align: center !important;
  padding: 1.25rem 0 !important;
  display: table-cell !important;
}
ngb-datepicker .ngb-dp-day,
ngb-datepicker .ngb-dp-weekday,
ngb-datepicker .ngb-dp-week-number,
ngb-datepicker .ngb-datepicker-day,
ngb-datepicker .ngb-datepicker-weekday,
ngb-datepicker .ngb-datepicker-week-number,
.ngb-datepicker .ngb-dp-day,
.ngb-datepicker .ngb-dp-weekday,
.ngb-datepicker .ngb-dp-week-number,
.ngb-datepicker .ngb-datepicker-day,
.ngb-datepicker .ngb-datepicker-weekday,
.ngb-datepicker .ngb-datepicker-week-number,
app-ngb-datepicker .ngb-datepicker .ngb-dp-day,
app-ngb-datepicker .ngb-datepicker .ngb-dp-weekday,
app-ngb-datepicker .ngb-datepicker .ngb-dp-week-number,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-day,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-weekday,
app-ngb-datepicker .ngb-datepicker .ngb-datepicker-week-number,
:host ::ng-deep .ngb-datepicker .ngb-dp-day,
:host ::ng-deep .ngb-datepicker .ngb-dp-weekday,
:host ::ng-deep .ngb-datepicker .ngb-dp-week-number,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-day,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-weekday,
:host ::ng-deep .ngb-datepicker .ngb-datepicker-week-number {
  width: 3.95rem !important;
  height: 2.3rem !important;
}

.ngb-dp-day, .ngb-dp-weekday, .ngb-dp-week-number {
  width: 3.95rem !important;
  height: 2.3rem !important;
}

.ngb-dp-navigation-chevron {
  transform: rotate(50deg) !important;
}

.ngb-dp-arrow-next .ngb-dp-navigation-chevron {
  transform: rotate(225deg) !important;
}

.ngb-dp-arrow-btn {
  margin-bottom: 0px !important;
}

:host-context([dir=rtl]) ::ng-deep .ngb-datepicker .ngb-datepicker-header {
  direction: rtl;
}
:host-context([dir=rtl]) ::ng-deep .ngb-datepicker .ngb-datepicker-days {
  direction: rtl;
}
:host-context([dir=rtl]) ::ng-deep .ngb-datepicker .ngb-datepicker-months {
  direction: rtl;
}
:host-context([dir=rtl]) ::ng-deep .ngb-datepicker .ngb-dp-weekdays {
  direction: rtl;
  width: 100% !important;
  display: table !important;
  table-layout: fixed !important;
}
:host-context([dir=rtl]) ::ng-deep .ngb-datepicker .ngb-datepicker-selected {
  background: linear-gradient(315deg, #667eea 0%, #764ba2 100%) !important;
}
:host-context([dir=rtl]) ::ng-deep .ngb-datepicker .ngb-datepicker-selected:hover {
  background: linear-gradient(315deg, #5568d3 0%, #6a4190 100%) !important;
}
:host-context([dir=rtl]) ::ng-deep .ngb-datepicker .ngb-datepicker-today {
  background: rgba(102, 126, 234, 0.1) !important;
  color: #667eea !important;
  font-weight: 600 !important;
  border: 2px solid #667eea !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/ngb-datepicker/ngb-datepicker.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;AACF;AAEE;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;AAAJ;AAEI;EACE,aAAA;EACA,cAAA;EACA,iBAAA;AAAN;AAGI;EACE,cAAA;AADN;AAII;EACE,yBAAA;EACA,iBAAA;EACA,mBAAA;AAFN;AAOE;EACE,aAAA;EACA,WAAA;EACA,oBAAA;AALJ;AAOI;EACE,OAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,iBAAA;AALN;AAOM;EACE,qBAAA;EACA,6CAAA;AALR;AAQM;EACE,qBAAA;AANR;AAOQ;EACE,4CAAA;AALV;AAWQ;EACE,gBAAA;EACA,8BAAA;EACA,kBAAA;AATV;AAYQ;EACE,iBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mBAAA;AAVV;AAgBI;EACE,OAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;AAdN;AAgBM;EACE,yBAAA;EACA,cAAA;AAdR;AAiBM;EACE,cAAA;AAfR;AAkBM;EACE,wBAAA;EACA,2BAAA;AAhBR;AAqBI;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAnBN;AAqBM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,6BAAA;AAnBR;AAsBM;EACE,oCAAA;EACA,2BAAA;EACA,gBAAA;AApBR;AAsBQ;EACE,UAAA;AApBV;AAwBM;EACE,wBAAA;AAtBR;AAyBM;EAEE,6DAAA;EACA,mBAAA;EACA,YAAA;AAxBR;AA2BM;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAzBR;AA4BM;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;AA1BR;AA+BI;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;AA7BN;AA+BM;EACE,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,2BAAA;EACA,4CAAA;AA7BR;AAgCM;EACE,wBAAA;AA9BR;AAiCM;EACE,WAAA;EACA,YAAA;AA/BR;AAoCI;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AAlCN;AAoCM;EACE,kCAAA;EACA,cAAA;AAlCR;AAqCM;EACE,WAAA;EACA,YAAA;AAnCR;AAyCE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,6DAAA;EACA,8BAAA;EACA,qBAAA;EACA,8BAAA;AAvCJ;AAyCI;EACE,cAAA;EACA,cAAA;EACA,0BAAA;AAvCN;AA0CI;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AAxCN;AA6CE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,6DAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;AA3CJ;AA6CI;EACE,cAAA;AA3CN;AAkDM;EACE,cAAA;AAhDR;AAkDQ;EACE,WAAA;EACA,YAAA;AAhDV;AAqDQ;EACE,4DAAA;AAnDV;AAwDI;EACE,cAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;AAtDN;AAyDI;EACE,cAAA;EACA,iBAAA;AAvDN;;AA6DA;EACE;IACE,UAAA;IACA,4BAAA;EA1DF;EA4DA;IACE,UAAA;IACA,wBAAA;EA1DF;AACF;AA6DA;EACE;IAAW,wBAAA;EA1DX;EA2DA;IAA0B,2BAAA;EAxD1B;EAyDA;IAAqB,0BAAA;EAtDrB;AACF;AAwDA;EACE;IACE,UAAA;IACA,2BAAA;EAtDF;EAwDA;IACE,UAAA;IACA,wBAAA;EAtDF;AACF;AA0DA;EAEI;IACE,eAAA;EAzDJ;EA2DI;IACE,gBAAA;IACA,qBAAA;EAzDN;EA4DI;;IAEE,gBAAA;EA1DN;EA8DE;IACE,kBAAA;EA5DJ;EA+DE;IACE,uBAAA;IACA,iBAAA;EA7DJ;EAgEE;IACE,sBAAA;IACA,iBAAA;EA9DJ;AACF;AAmEA;EACE;IACE,sBAAA;EAjEF;EAmEE;IACE,wCAAA;IACA,0BAAA;IACA,2BAAA;IACA,4BAAA;IACA,4BAAA;EAjEJ;EAoEE;IACE,wCAAA;IACA,0BAAA;IACA,4BAAA;EAlEJ;AACF;AAuEA;EACE;IACE,sBAAA;EArEF;EAuEE;IACE,0BAAA;IACA,2BAAA;IACA,sBAAA;IACA,uBAAA;IACA,4BAAA;IACA,4BAAA;EArEJ;EAwEE;IACE,wCAAA;IACA,0BAAA;IACA,4BAAA;EAtEJ;AACF;AA4EA;;;;EAIE,sBAAA;EACA,8BAAA;EACA,qDAAA;EACA,uBAAA;EACA,4BAAA;EACA,+BAAA;EAEA,6BAAA;EACA,wBAAA;AA3EF;AA8EE;;;;EACE,wBAAA;AAzEJ;AA4EE;;;;EACE,wEAAA;EACA,uBAAA;EACA,+BAAA;EACA,uCAAA;EACA,sBAAA;EACA,yBAAA;AAvEJ;AAyEI;;;;EACE,uBAAA;EACA,2BAAA;AApEN;AAuEQ;;;;EACE,+CAAA;EACA,kBAAA;AAlEV;AAqEQ;;;;EACE,sBAAA;EACA,uBAAA;AAhEV;AAsEE;;;;EACE,wBAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BAAA;AAjEJ;AAoEE;;;;EACE,sBAAA;EACA,6BAAA;EACA,8BAAA;AA/DJ;AAkEE;;;;EACE,8BAAA;EACA,yCAAA;EACA,2CAAA;EACA,wBAAA;EACA,yCAAA;EACA,sBAAA;AA7DJ;AA+DI;;;;EACE,kBAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;EACA,kCAAA;EACA,gCAAA;AA1DN;AA4DM;;;;EACE,+CAAA;EACA,yBAAA;AAvDR;AA4DE;;;;EACE,0BAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;AAvDJ;AAyDI;;;;EACE,wCAAA;EACA,0BAAA;EACA,4BAAA;AApDN;AAwDE;;;;EACE,6BAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;AAnDJ;AAqDI;;;;EACE,6BAAA;EACA,oCAAA;EACA,4BAAA;EACA,yBAAA;EACA,4BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;AAhDN;AAkDM;;;;EACE,+CAAA;AA7CR;AAgDM;;;;EACE,yBAAA;EACA,wCAAA;AA3CR;AA8CM;;;;EACE,yBAAA;AAzCR;AA6CI;;;;EACE,+CAAA;EACA,yBAAA;EACA,2BAAA;EACA,oCAAA;AAxCN;AA2CI;;;;EACE,wEAAA;EACA,uBAAA;EACA,2BAAA;AAtCN;AAwCM;;;;EACE,wEAAA;AAnCR;AAwCE;;;;EACE,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;EACA,6CAAA;EACA,8BAAA;AAnCJ;AAsCE;;;;EACE,yBAAA;EACA,4BAAA;EACA,6BAAA;EACA,6BAAA;EACA,8BAAA;AAjCJ;AAqCE;;;;;;;;;;;;;;;;;;;;;;;;EAME,yBAAA;EACA,yBAAA;AAjBJ;;AAqBA;EACE,yBAAA;EACA,yBAAA;AAlBF;;AAsBA;EACE,mCAAA;AAnBF;;AAsBA;EACE,oCAAA;AAnBF;;AAsBA;EACE,6BAAA;AAnBF;;AAwBI;EACE,cAAA;AArBN;AAwBI;EACE,cAAA;AAtBN;AAyBI;EACE,cAAA;AAvBN;AA0BI;EACE,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BAAA;AAxBN;AA2BI;EACE,wEAAA;AAzBN;AA2BM;EACE,wEAAA;AAzBR;AA6BI;EACE,+CAAA;EACA,yBAAA;EACA,2BAAA;EACA,oCAAA;AA3BN","sourcesContent":[".ngb-datepicker-wrapper {\r\n  margin-bottom: 1rem;\r\n  position: relative;\r\n\r\n  // Enhanced label styling\r\n  .enhanced-label {\r\n    font-weight: 600;\r\n    margin-bottom: 0.5rem;\r\n    display: block;\r\n    font-size: 0.9rem;\r\n    color: #2c3e50;\r\n\r\n    &.required::after {\r\n      content: ' *';\r\n      color: #e74c3c;\r\n      font-weight: bold;\r\n    }\r\n\r\n    .label-text {\r\n      color: #34495e;\r\n    }\r\n\r\n    .optional-hint {\r\n      color: #7f8c8d !important;\r\n      font-size: 0.85em;\r\n      font-weight: normal;\r\n    }\r\n  }\r\n\r\n  // Enhanced input group styling\r\n  .enhanced-input-group {\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    align-items: stretch;\r\n\r\n    .datepicker-input-container {\r\n      flex: 1;\r\n      display: flex;\r\n      position: relative;\r\n      border: 1px solid #dee2e6;\r\n      border-radius: 0.5rem;\r\n      transition: all 0.3s ease;\r\n      background: white;\r\n\r\n      &:focus-within {\r\n        border-color: #3498db;\r\n        box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);\r\n      }\r\n\r\n      &.has-error {\r\n        border-color: #e74c3c;\r\n        &:focus-within {\r\n          box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.1);\r\n        }\r\n      }\r\n\r\n      // Time input styling\r\n      &.with-time {\r\n        .enhanced-input.time-input {\r\n          max-width: 140px;\r\n          border-left: 1px solid #dee2e6;\r\n          padding-left: 1rem;\r\n        }\r\n\r\n        &.rtl-mode .enhanced-input.time-input {\r\n          border-left: none;\r\n          border-right: 1px solid #dee2e6;\r\n          padding-left: 1rem;\r\n          padding-right: 1rem;\r\n        }\r\n      }\r\n    }\r\n\r\n    // Enhanced input styling\r\n    .enhanced-input {\r\n      flex: 1;\r\n      border: none !important;\r\n      border-radius: 0 !important;\r\n      padding: 0.75rem 1rem;\r\n      font-size: 0.95rem;\r\n      background: transparent;\r\n      transition: all 0.2s ease;\r\n\r\n      &.is-disabled {\r\n        background-color: #f8f9fa;\r\n        color: #6c757d;\r\n      }\r\n\r\n      &::placeholder {\r\n        color: #adb5bd;\r\n      }\r\n\r\n      &:focus {\r\n        outline: none !important;\r\n        box-shadow: none !important;\r\n      }\r\n    }\r\n\r\n    // Enhanced calendar button\r\n    .enhanced-calendar-btn {\r\n      background: transparent;\r\n      border: none;\r\n      color: #6c757d;\r\n      padding: 0 1rem;\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 0.5rem;\r\n      transition: all 0.3s ease;\r\n      position: relative;\r\n      overflow: hidden;\r\n\r\n      &::before {\r\n        content: '';\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 100%;\r\n        background: transparent;\r\n        opacity: 0;\r\n        transition: opacity 0.3s ease;\r\n      }\r\n\r\n      &:hover:not(.btn-disabled):not(:disabled) {\r\n        background: rgba(108, 117, 125, 0.1);\r\n        transform: translateY(-1px);\r\n        box-shadow: none;\r\n\r\n        &::before {\r\n          opacity: 1;\r\n        }\r\n      }\r\n\r\n      &:active:not(.btn-disabled):not(:disabled) {\r\n        transform: translateY(0);\r\n      }\r\n\r\n      &.btn-disabled,\r\n      &:disabled {\r\n        background: linear-gradient(135deg, #adb5bd 0%, #6c757d 100%);\r\n        cursor: not-allowed;\r\n        opacity: 0.6;\r\n      }\r\n\r\n      svg {\r\n        width: 18px;\r\n        height: 18px;\r\n        flex-shrink: 0;\r\n      }\r\n\r\n      .btn-text {\r\n        font-size: 0.85rem;\r\n        font-weight: 500;\r\n        letter-spacing: 0.5px;\r\n      }\r\n    }\r\n\r\n    // Clear button\r\n    .clear-btn {\r\n      background: #f8f9fa;\r\n      border: 1px solid #dee2e6;\r\n      color: #6c757d;\r\n      padding: 0 0.75rem;\r\n      border-radius: 0.5rem;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      transition: all 0.3s ease;\r\n      flex-shrink: 0;\r\n\r\n      &:hover {\r\n        background: #e74c3c;\r\n        border-color: #e74c3c;\r\n        color: white;\r\n        transform: translateY(-1px);\r\n        box-shadow: 0 4px 8px rgba(231, 76, 60, 0.3);\r\n      }\r\n\r\n      &:active {\r\n        transform: translateY(0);\r\n      }\r\n\r\n      svg {\r\n        width: 16px;\r\n        height: 16px;\r\n      }\r\n    }\r\n\r\n    // Inline clear button\r\n    .clear-btn-inline {\r\n      background: transparent;\r\n      border: none;\r\n      color: #6c757d;\r\n      padding: 0.5rem;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      transition: all 0.2s ease;\r\n      position: absolute;\r\n      right: 0.5rem;\r\n      top: 50%;\r\n      transform: translateY(-50%);\r\n      cursor: pointer;\r\n\r\n      &:hover {\r\n        background: rgba(231, 76, 60, 0.1);\r\n        color: #e74c3c;\r\n      }\r\n\r\n      svg {\r\n        width: 16px;\r\n        height: 16px;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Enhanced validation feedback\r\n  .enhanced-invalid-feedback {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    margin-top: 0.5rem;\r\n    padding: 0.75rem 1rem;\r\n    background: linear-gradient(135deg, #fff5f5 0%, #fed7d7 100%);\r\n    border-left: 4px solid #e74c3c;\r\n    border-radius: 0.5rem;\r\n    animation: slideDown 0.3s ease;\r\n\r\n    .error-icon {\r\n      color: #e74c3c;\r\n      flex-shrink: 0;\r\n      animation: shake 0.5s ease;\r\n    }\r\n\r\n    .error-text {\r\n      color: #c0392b;\r\n      font-size: 0.875rem;\r\n      font-weight: 500;\r\n    }\r\n  }\r\n\r\n  // Selected date display\r\n  .date-display {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    margin-top: 0.5rem;\r\n    padding: 0.5rem 0.75rem;\r\n    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\r\n    border-radius: 0.5rem;\r\n    color: #0369a1;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    animation: fadeIn 0.3s ease;\r\n\r\n    svg {\r\n      flex-shrink: 0;\r\n    }\r\n  }\r\n\r\n  // RTL Mode\r\n  &.rtl-mode {\r\n    .enhanced-input-group {\r\n      .datepicker-input-container {\r\n        direction: rtl;\r\n\r\n        .clear-btn-inline {\r\n          right: auto;\r\n          left: 0.5rem;\r\n        }\r\n      }\r\n\r\n      .enhanced-calendar-btn {\r\n        .btn-text {\r\n          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n        }\r\n      }\r\n    }\r\n\r\n    .enhanced-invalid-feedback {\r\n      direction: rtl;\r\n      border-left: none;\r\n      border-right: 4px solid #e74c3c;\r\n      text-align: right;\r\n    }\r\n\r\n    .date-display {\r\n      direction: rtl;\r\n      text-align: right;\r\n    }\r\n  }\r\n}\r\n\r\n// Animations\r\n@keyframes slideDown {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes shake {\r\n  0%, 100% { transform: translateX(0); }\r\n  10%, 30%, 50%, 70%, 90% { transform: translateX(-4px); }\r\n  20%, 40%, 60%, 80% { transform: translateX(4px); }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-5px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n// Responsive adjustments\r\n@media (max-width: 576px) {\r\n  .ngb-datepicker-wrapper {\r\n    .enhanced-input-group {\r\n      flex-wrap: wrap;\r\n\r\n      .datepicker-input-container {\r\n        flex-basis: 100%;\r\n        margin-bottom: 0.5rem;\r\n      }\r\n\r\n      .enhanced-calendar-btn,\r\n      .clear-btn {\r\n        flex-basis: auto;\r\n      }\r\n    }\r\n\r\n    .enhanced-label {\r\n      font-size: 0.85rem;\r\n    }\r\n\r\n    .enhanced-invalid-feedback {\r\n      padding: 0.5rem 0.75rem;\r\n      font-size: 0.8rem;\r\n    }\r\n\r\n    .date-display {\r\n      padding: 0.4rem 0.6rem;\r\n      font-size: 0.8rem;\r\n    }\r\n  }\r\n}\r\n\r\n// Responsive breakpoints for different screen sizes\r\n@media (min-width: 992px) {\r\n  :host ::ng-deep .ngb-datepicker {\r\n    width: 100% !important;\r\n\r\n    .ngb-datepicker-day {\r\n      width: -webkit-fill-available !important;\r\n      min-width: 80px !important;\r\n      min-height: 80px !important;\r\n      padding: 12px 8px !important;\r\n      font-size: 1.3rem !important;\r\n    }\r\n\r\n    .ngb-datepicker-weekday {\r\n      width: -webkit-fill-available !important;\r\n      min-width: 80px !important;\r\n      font-size: 1.2rem !important;\r\n    }\r\n  }\r\n}\r\n\r\n// Medium tablets - flexible sizing\r\n@media (min-width: 768px) and (max-width: 991px) {\r\n  :host ::ng-deep .ngb-datepicker {\r\n    width: 100% !important;\r\n\r\n    .ngb-datepicker-day {\r\n      min-width: 70px !important;\r\n      min-height: 70px !important;\r\n      width: 70px !important;\r\n      height: 70px !important;\r\n      line-height: 70px !important;\r\n      font-size: 1.2rem !important;\r\n    }\r\n\r\n    .ngb-datepicker-weekday {\r\n      width: -webkit-fill-available !important;\r\n      min-width: 70px !important;\r\n      font-size: 1.1rem !important;\r\n    }\r\n  }\r\n}\r\n\r\n// ng-bootstrap dropdown styling customization\r\n// With ViewEncapsulation.None, these styles will be global and take precedence\r\nngb-datepicker,\r\n.ngb-datepicker,\r\napp-ngb-datepicker .ngb-datepicker,\r\n:host ::ng-deep .ngb-datepicker {\r\n  width: 100% !important;\r\n  border-radius: 1rem !important;\r\n  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.2) !important;\r\n  border: none !important;\r\n  overflow: visible !important;\r\n  font-family: inherit !important;\r\n\r\n  position: absolute !important;\r\n  z-index: 1000 !important;\r\n\r\n  // Hide any potential jQuery UI datepicker elements\r\n  .ui-datepicker {\r\n    display: none !important;\r\n  }\r\n\r\n  .ngb-dp-header {\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\r\n    color: white !important;\r\n    padding: 2.5rem 3rem !important;\r\n    border-radius: 1rem 1rem 0 0 !important;\r\n    width: 100% !important;\r\n    display: block !important;\r\n\r\n    .ngb-datepicker-navigation {\r\n      color: white !important;\r\n      padding: 0.75rem !important;\r\n\r\n      .ngb-navigation-chevron {\r\n        &:hover {\r\n          background: rgba(255, 255, 255, 0.2) !important;\r\n          border-radius: 50%;\r\n        }\r\n\r\n        svg {\r\n          width: 24px !important;\r\n          height: 24px !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .ngb-dp-months {\r\n    padding: 3rem !important;\r\n    width: 100% !important;\r\n    display: block !important;\r\n    overflow-x: visible !important;\r\n  }\r\n\r\n  .ngb-dp-weekdays {\r\n    width: 100% !important;\r\n    display: table-row !important;\r\n    table-layout: fixed !important;\r\n  }\r\n\r\n  .ngb-datepicker-month-names {\r\n    background: #f8f9fa !important;\r\n    padding: 2rem 3rem 1.5rem 3rem !important;\r\n    border-bottom: 1px solid #dee2e6 !important;\r\n    display: flex !important;\r\n    justify-content: space-between !important;\r\n    width: 100% !important;\r\n\r\n    .ngb-month-name {\r\n      flex: 1 !important;\r\n      text-align: center !important;\r\n      font-size: 1.3rem !important;\r\n      font-weight: 500 !important;\r\n      color: #495057 !important;\r\n      padding: 1.25rem 0.5rem !important;\r\n      border-radius: 0.5rem !important;\r\n\r\n      &:hover {\r\n        background: rgba(102, 126, 234, 0.1) !important;\r\n        color: #667eea !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  .ngb-dp-weekdays {\r\n    padding: 0 2rem !important;\r\n    display: table !important;\r\n    width: 100% !important;\r\n    table-layout: fixed !important;\r\n\r\n    .ngb-dp-weekday {\r\n      width: -webkit-fill-available !important;\r\n      min-width: 80px !important;\r\n      font-size: 1.1rem !important;\r\n    }\r\n  }\r\n\r\n  .ngb-datepicker-days {\r\n    padding: 2rem 2rem !important;\r\n    display: table !important;\r\n    width: 100% !important;\r\n    table-layout: fixed !important;\r\n\r\n    .ngb-datepicker-day {\r\n      border-radius: 50% !important;\r\n      transition: all 0.2s ease !important;\r\n      padding: 12px 8px !important;\r\n      margin: 0.2rem !important;\r\n      font-size: 1.2rem !important;\r\n      line-height: 1.4 !important;\r\n      display: table-cell !important;\r\n      text-align: center !important;\r\n\r\n      &:hover {\r\n        background: rgba(102, 126, 234, 0.1) !important;\r\n      }\r\n\r\n      &.disabled {\r\n        color: #dee2e6 !important;\r\n        text-decoration: line-through !important;\r\n      }\r\n\r\n      &.outside-month {\r\n        color: #adb5bd !important;\r\n      }\r\n    }\r\n\r\n    .ngb-datepicker-today {\r\n      background: rgba(102, 126, 234, 0.1) !important;\r\n      color: #667eea !important;\r\n      font-weight: 600 !important;\r\n      border: 2px solid #667eea !important;\r\n    }\r\n\r\n    .ngb-datepicker-selected {\r\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\r\n      color: white !important;\r\n      font-weight: 600 !important;\r\n\r\n      &:hover {\r\n        background: linear-gradient(135deg, #5568d3 0%, #6a4190 100%) !important;\r\n      }\r\n    }\r\n  }\r\n\r\n  .ngb-datepicker-weekday {\r\n    color: #6c757d !important;\r\n    font-weight: 600 !important;\r\n    font-size: 1.1rem !important;\r\n    text-align: center !important;\r\n    padding: 1.2rem 0.5rem 1rem 0.5rem !important;\r\n    display: table-cell !important;\r\n  }\r\n\r\n  .ngb-datepicker-week-number {\r\n    color: #adb5bd !important;\r\n    font-size: 1.2rem !important;\r\n    text-align: center !important;\r\n    padding: 1.25rem 0 !important;\r\n    display: table-cell !important;\r\n  }\r\n\r\n  // Day cell, weekday, and week number fixed dimensions\r\n  .ngb-dp-day,\r\n  .ngb-dp-weekday,\r\n  .ngb-dp-week-number,\r\n  .ngb-datepicker-day,\r\n  .ngb-datepicker-weekday,\r\n  .ngb-datepicker-week-number {\r\n    width: 3.95rem !important;\r\n    height: 2.3rem !important;\r\n  }\r\n}\r\n\r\n.ngb-dp-day, .ngb-dp-weekday, .ngb-dp-week-number{\r\n  width: 3.95rem !important;\r\n  height: 2.3rem !important;\r\n}\r\n\r\n// Arabic-specific chevron transforms\r\n.ngb-dp-navigation-chevron {\r\n  transform: rotate(50deg) !important;\r\n}\r\n\r\n.ngb-dp-arrow-next .ngb-dp-navigation-chevron {\r\n  transform: rotate(225deg) !important;\r\n}\r\n\r\n.ngb-dp-arrow-btn {\r\n  margin-bottom: 0px !important;\r\n}\r\n// RTL-specific ng-bootstrap styling\r\n:host-context([dir='rtl']) {\r\n  ::ng-deep .ngb-datepicker {\r\n    .ngb-datepicker-header {\r\n      direction: rtl;\r\n    }\r\n\r\n    .ngb-datepicker-days {\r\n      direction: rtl;\r\n    }\r\n\r\n    .ngb-datepicker-months {\r\n      direction: rtl;\r\n    }\r\n\r\n    .ngb-dp-weekdays {\r\n      direction: rtl;\r\n      width: 100% !important;\r\n      display: table !important;\r\n      table-layout: fixed !important;\r\n    }\r\n    // Reverse the selected date gradient for RTL\r\n    .ngb-datepicker-selected {\r\n      background: linear-gradient(315deg, #667eea 0%, #764ba2 100%) !important;\r\n\r\n      &:hover {\r\n        background: linear-gradient(315deg, #5568d3 0%, #6a4190 100%) !important;\r\n      }\r\n    }\r\n    // Reverse today's indicator border for RTL\r\n    .ngb-datepicker-today {\r\n      background: rgba(102, 126, 234, 0.1) !important;\r\n      color: #667eea !important;\r\n      font-weight: 600 !important;\r\n      border: 2px solid #667eea !important;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
